import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SEO = ({ 
  title = "IMMO CONCEPT | Promoteur Immobilier Suisse Romande",
  description = "Promoteur immobilier de prestige en Suisse Romande. Spécialisé dans la promotion immobilière, vente, construction et gestion de biens d'exception à Verbier, Épalinges et toute la Suisse Romande.",
  keywords = "promoteur immobilier suisse, immobilier suisse romande, chalet verbier, promotion immobilière épalinges, immobilier prestige suisse, construction chalet suisse, gestion immobilière lausanne, investissement immobilier suisse",
  image = "https://customer-assets.emergentagent.com/job_property-promo-3/artifacts/7m24zpxw_IMMO%20CONCEPT-1.png",
  url = "https://real-estate-build-1.preview.emergentagent.com",
  type = "website"
}) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "RealEstateAgent",
    "name": "IMMO CONCEPT",
    "description": description,
    "url": url,
    "logo": image,
    "image": image,
    "telephone": "+41795100855",
    "email": "guillaume@immoconceptsuisse.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Route de berne 223",
      "addressLocality": "Epalinges",
      "postalCode": "1066",
      "addressCountry": "CH"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "46.5547",
      "longitude": "6.6619"
    },
    "areaServed": [
      {
        "@type": "City",
        "name": "Verbier"
      },
      {
        "@type": "City",
        "name": "Épalinges"
      },
      {
        "@type": "City",
        "name": "Lausanne"
      },
      {
        "@type": "State",
        "name": "Suisse Romande"
      }
    ],
    "priceRange": "CHF",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      }
    ],
    "sameAs": [
      "https://www.linkedin.com/company/immoconcept-rieme/"
    ]
  };

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="IMMO CONCEPT" />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="IMMO CONCEPT" />
      <meta property="og:locale" content="fr_CH" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="language" content="French" />
      <meta name="geo.region" content="CH-VD" />
      <meta name="geo.placename" content="Epalinges" />
      <meta name="geo.position" content="46.5547;6.6619" />
      <meta name="ICBM" content="46.5547, 6.6619" />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};